export enum SpecialGameRule {
  EVERYONE_IS_HERE = "EVERYONE_IS_HERE",
  UNIQUE_STARTER = "UNIQUE_STARTER",
  OMELETTE_COOK = "OMELETTE_COOK",
  DITTO_PARTY = "DITTO_PARTY",
  GOTTA_CATCH_EM_ALL = "GOTTA_CATCH_EM_ALL",
  TECHNOLOGIC = "TECHNOLOGIC",
  CROWDED = "CROWDED",
  FREE_MARKET = "FREE_MARKET",
  SHINY_HUNTER = "SHINY_HUNTER",
  DO_IT_ALL_YOURSELF = "DO_IT_ALL_YOURSELF",
  FIRST_PARTNER = "FIRST_PARTNER",
  SLAMINGO = "SLAMINGO",
  BLOOD_MONEY = "BLOOD_MONEY",
  TOWN_FESTIVAL = "TOWN_FESTIVAL",
  HIGH_ROLLER = "HIGH_ROLLER",
  REGIONAL_SPECIALTIES = "REGIONAL_SPECIALTIES",
  GO_BIG_OR_GO_HOME = "GO_BIG_OR_GO_HOME",
  FAMILY_OUTING = "FAMILY_OUTING",
  UNOWN_SPELL = "UNOWN_SPELL",
  CHOSEN_ONES = "CHOSEN_ONES"
}
